module.exports = __webpack_public_path__ + "static/media/downwards.c873d51c.svg";